import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, LocationTypes } from '@zendra/shared';
import { ConservationTypeService, LocationService } from 'cbd-proxies';
import { ProtectedAreaOtherUseDetail } from '../protected-area-other-use-detail/protected-area-other-use-detail';

FieldBuilder.setNamespace('Geographic');

export const PROTECTEDAREA_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ProtectedArea.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('area', 'Entity.ProtectedArea.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('recordNumber', 'Entity.ProtectedArea.RecordNumber')
    .build(),
  FieldBuilder
    .number('officialArea', 'Entity.ProtectedArea.OfficialArea')
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isDinamaProtected', 'Entity.ProtectedArea.IsDinamaProtected')
    .build(),
  FieldBuilder.foreignKey(
    'propertyLocationId',
    'Entity.Property',
    LocationService
  )
    .queryFilter({ locationTypeEntityName: LocationTypes.Property })
    .display('name')
    .displayFromNested('propertyLocationName')
    .sortBy('propertyLocationName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'conservationTypeId',
    'Entity.ConservationType',
    ConservationTypeService
  )
    .display('description')
    .displayFromNested('conservationTypeDescription')
    .sortBy('conservationTypeDescription')
    .keyField('id')
    .build(),
];

export const PROTECTEDAREA_CONFIG = {
  entityName: 'ProtectedArea',
  localizationKey: 'Geographic::Entity.ProtectedArea',
  fields: PROTECTEDAREA_FIELDS,
  permission: 'PlanningGeography.ProtectedAreas',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Environment + MENU_NAME_SUFFIX,
  menuSubcategory: '',
  children: [
    {
        entityName: 'ProtectedAreaOtherUseDetail',
        foreignKeyField: 'protectedAreaId',
        localizationKey: 'Geographic::Entity.ProtectedAreaOtherUseDetail',
        component: ProtectedAreaOtherUseDetail,
    }
  ]
};
